import { MediaQuery } from '@grandvisionhq/common';
import { useStoreFinderContext } from '../context/StoreFinder/context.js';

const useTabs = ()=>{
    const { isPristineSearch  } = useStoreFinderContext();
    const isMobile = MediaQuery.useIsPhone();
    return isMobile && !isPristineSearch;
};

export { useTabs };
//# sourceMappingURL=use-tabs.js.map
